/**
 *
 * @author Iecisa
 */
export class AuthenticationDTO {
    username: string;
    password: string;
}
